<!--- Generic header, inclusing current brand and a button to select another brand -->

<div class="grid">
    <div class="col-8">
        <app-brand-admin-header></app-brand-admin-header>
    </div>  
<!-- 
    @if (isSubmitShown) {
        <div class="col-1">
            <button pButton type="button" label="Submit" icon="pi pi-" iconPos="left" (click)="onSubmit($event)"  
                class="p-button-raised p-button-rounded">
            </button>
        </div>
    }
    <div class="col-2">
        <button pButton type="button" label="Back to Field Set" icon="pi pi-backward" iconPos="left" (click)="brandOfferRedirect($event)"  
            class="p-button-raised p-button-rounded" [disabled]="isDetailsShown">
        </button>
    </div>
 -->
</div> 

<div class="grid">

    <div class="col-8">

        <p-tabs class="wal-tabs" [(value)]="tabIndex">

          <p-tablist>

            <p-tab [value]="'Apple Wallet'">
              <span class="tab-label">
                <i class="pi pi-user-edit" aria-hidden="true"></i>
                <span class="ml-2">Apple Wallet</span>
              </span>
            </p-tab>

            <p-tab [value]="'Google Wallet'">
              <span class="tab-label">
                <i class="pi pi-check-circle" aria-hidden="true"></i>
                <span class="ml-2">Google Wallet</span>
              </span>
            </p-tab>

            <p-tab [value]="'Samsung Wallet'" [hidden]="isSamsungPlatformDisabled">
              <span class="tab-label">
                <i class="pi pi-sitemap" aria-hidden="true"></i>
                <span class="ml-2">Samsung Wallet</span>
              </span>
            </p-tab>

          </p-tablist>  

          <p-tabpanels>

            <p-tabpanel [value]="'Apple Wallet'">

                <ng-template pTemplate="header">
                  <img src="../../../assets/images/apple-wallet.png" width="16" height="16" style="margin-right: 8px;" />
                    Apple Wallet
                </ng-template>

                <app-pass-layout [messageObservable]="awMessage$" [onNotify]="onNotifySignal">
                </app-pass-layout>       

            </p-tabpanel>

            <p-tabpanel [value]="'Google Wallet'">

                <ng-template pTemplate="header">
                  <img src="../../../assets/images/google_wallet.svg" width="16" height="16" style="margin-right: 8px;" />
                    Google Wallet
                </ng-template>

                <app-pass-layout [messageObservable]="gwMessage$" [onNotify]="onNotifySignal">
                </app-pass-layout>       

            </p-tabpanel>

            <p-tabpanel [value]="'Samsung Wallet'">

                <ng-template pTemplate="header">
                <img src="../../../assets/images/samsung-wallet.jpg" width="16" height="16" style="margin-right: 8px;" />
                    Samsung Wallet
                </ng-template>

                <app-pass-layout [messageObservable]="swMessage$" [onNotify]="onNotifySignal">
                </app-pass-layout>       

            </p-tabpanel>

          </p-tabpanels>        

        </p-tabs>


    </div>


    @if (isFieldDetailsShown) {
        <div class="col-3">
            <p-card header="Field Details" subheader="" class="ui-card-light-rounded">
                <div>
                    <p-table #dt [columns]="fieldDetailsCols" [value]="fieldDetails" 
                        selectionMode="single" [paginator]="false" class="wal-table">
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData">
                                @for (col of columns; track col.field) {
                                    <td [style.width]="col.width" [style.display]="col.display">
                                        {{ rowData[col.field] }}
                                    </td>
                                }
                            </tr>
                        </ng-template>
                    </p-table> 
                </div>
            </p-card>
        </div>
    }


</div>

<div class="form-row" style="text-align:left">
    @if (isSubmitShown) {
        <p-button type="submit" label="Submit" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSubmit($event)"></p-button>
    }
    <p-button type="button" label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="onCancel($event)"></p-button>
</div>                    


<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="offer-pass-layouts"></p-confirmDialog>